<template>
    <v-expansion-panels>
        <v-expansion-panel class="condensed" v-for="(item,i) in items" :key="i">
            <v-expansion-panel-header>{{item.title}}</v-expansion-panel-header>
            <v-expansion-panel-content>
                <v-row v-for="(row,i) in item.rows" :key="i">
                    <v-col v-for="(column,i) in row.columns" :key="i" cols="12" md="5">
                        <h4>{{column.title}}</h4>
                        <p>{{column.content}}</p>
                    </v-col>
                </v-row>
                <div class="flex-end">
                    <v-btn class="text-none" dark color="#C4170C" v-for="(action,i) in item.actions" :key="i" v-bind:disabled="action.disabled" v-on:click="$emit(action.eventName,action.dataToReturn)">{{action.name}}</v-btn>
                </div>
            </v-expansion-panel-content>
        </v-expansion-panel>
    </v-expansion-panels>
</template>

<script>
export default {
    name:'BaseExpansionPanels',
    props:{
        items:{
            type:Array
        }
    },
    created:function(){
    }
}
</script>

<style scoped>
    .flex-end{
        display: flex;
        width: 100%;
        align-items: center;
        justify-content: flex-end;
    }

    .v-expansion-panel.condensed{
        margin-bottom: 5px;
    }
</style>